import React from 'react';
import { Lock, Crown } from 'lucide-react';
import { Link } from 'react-router-dom';

const VIP = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 text-center">
      <div className="bg-gray-800 p-8 rounded-2xl shadow-2xl max-w-2xl w-full border border-gray-700">
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-yellow-500/20 mb-6">
          <Crown className="h-10 w-10 text-yellow-500" />
        </div>
        <h2 className="text-3xl font-extrabold text-white sm:text-4xl mb-4">
          VIP Member Area
        </h2>
        <p className="text-xl text-gray-300 mb-8">
          This content is exclusive to our VIP members. Join the top 1% of students and get access to premium mentorship, resources, and events.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/signin"
            className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700 transition-colors"
          >
            <Lock className="w-4 h-4 mr-2" />
            Login to Access
          </Link>
          <Link
            to="/signup"
            className="inline-flex items-center justify-center px-6 py-3 border border-yellow-500 text-base font-medium rounded-md text-yellow-500 hover:bg-yellow-500/10 transition-colors"
          >
            Become a VIP
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VIP;
